import { render, staticRenderFns } from "./RegulationDashboard.vue?vue&type=template&id=319c6858&"
import script from "./RegulationDashboard.vue?vue&type=script&lang=js&"
export * from "./RegulationDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports